import { Injectable, inject } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import { ElderToastService } from '@elderbyte/ngx-starter'
import { EMPTY, Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { BatchTracingSpecService } from './batch-tracing-spec.service'
import { BatchTracingSpec } from './batch-tracing-spec'

@Injectable({
  providedIn: 'root',
})
export class BatchTracingSpecResolver {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)
  private batchTracingSpecService = inject(BatchTracingSpecService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public resolve(route: ActivatedRouteSnapshot): Observable<BatchTracingSpec> {
    const id = route.paramMap.get('id')

    return this.batchTracingSpecService.findById(id).pipe(
      catchError((err) => {
        this.toastService.error('messages.loading_failed', err)
        return EMPTY
      })
    )
  }
}
